// actions.ts
import { SET_OFERTAS, OfertaResponse } from './types';

export const setOfertas = (ofertas: OfertaResponse[]) => ({
    type: SET_OFERTAS,
    payload: ofertas
});